export default "__VITE_ASSET__DK0yv0LH__"